import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const { server_url: serverUrl } = config[env]

export const state = {
    userAnswers: { results: [] },
}

export const getters = {
    userAnswers: (state) => state.userAnswers,
}

export const mutations = {
    CACHE_USER_ANSWERS(state, data) {
        state.userAnswers = data
    },
}

export const actions = {
    fetchUserAnswers({ commit }, params) {
        return axios.get(`${serverUrl}/assessment/user_answer/`, {
            params,
        }).then(res => {
            commit('CACHE_USER_ANSWERS', res.data)
            return res
        })
    },

    saveMultipleAnswers(_, payload) {
        return axios.post(`${serverUrl}/assessment/user_answer/save_multiple_answers/`, payload)
    },
    deleteIndependentQuestion(_, payload) {
        return axios.post(`${serverUrl}/assessment/user_answer/delete_independents_questions/`, payload)
    },
    deleteAllQuestion(_, payload) {
        return axios.post(`${serverUrl}/assessment/user_answer/delete_all_intraocupational_questions/`, payload)
    }
}